import { useState, useEffect } from 'react';

export const useCountdown = (initialHours = 23, initialMinutes = 47, initialSeconds = 15) => {
  const [time, setTime] = useState({
    hours: initialHours,
    minutes: initialMinutes,
    seconds: initialSeconds
  });

  useEffect(() => {
    // Try to get saved time from localStorage to maintain consistency on refresh
    const savedTime = localStorage.getItem('marketing_timer');
    if (savedTime) {
      const parsed = JSON.parse(savedTime);
      const now = new Date().getTime();
      const diff = Math.max(0, parsed.target - now);
      
      if (diff > 0) {
        setTime({
          hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((diff / (1000 * 60)) % 60),
          seconds: Math.floor((diff / 1000) % 60)
        });
      } else {
        // Reset if expired
        resetTimer();
      }
    } else {
      resetTimer();
    }

    function resetTimer() {
      const target = new Date().getTime() + 
        (initialHours * 3600 + initialMinutes * 60 + initialSeconds) * 1000;
      localStorage.setItem('marketing_timer', JSON.stringify({ target }));
    }

    const timer = setInterval(() => {
      setTime(prev => {
        let { hours, minutes, seconds } = prev;

        if (seconds > 0) {
          seconds--;
        } else {
          if (minutes > 0) {
            minutes--;
            seconds = 59;
          } else {
            if (hours > 0) {
              hours--;
              minutes = 59;
              seconds = 59;
            } else {
              // Timer finished - loop it for marketing continuity
              hours = initialHours;
              minutes = initialMinutes;
              seconds = initialSeconds;
              resetTimer();
            }
          }
        }
        return { hours, minutes, seconds };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return time;
};